export default function CardRow({ content = "" }) {
  return (
    <div className="ui-card mt-3 rounded-none px-5 py-3 lg:p-5 lg:px-6">
      {content}
    </div>
  );
}
